import { useQuery } from 'react-query'
import { ExternalIntegrationsClient } from 'api/clients/ExternalIntegrationsClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

interface UseValidateLocationProps {
  integrationId: number | undefined
  geoUrn: string | undefined
}

export const useValidateLocation = ({ integrationId, geoUrn }: UseValidateLocationProps) => {
  const workspaceId = useCurrentWorkspaceId()

  return useQuery(
    ['validateLocation', workspaceId, integrationId, geoUrn],
    async () => {
      if (!integrationId || !geoUrn) return null

      const response = await ExternalIntegrationsClient.validateLocation({
        workspaceId,
        integrationId,
        geoUrn,
      })

      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error('Failed to validate location')
      }

      return response.data
    },

    {
      enabled: !!workspaceId && !!integrationId && !!geoUrn,
      staleTime: 1000 * 60 * 10,
      cacheTime: 1000 * 60 * 10,
      retry: false,
    },
  )
}
